import { render, staticRenderFns } from "./BusDataCenterConfigurationList.vue?vue&type=template&id=5b092863&scoped=true&"
import script from "./BusDataCenterConfigurationList.vue?vue&type=script&lang=js&"
export * from "./BusDataCenterConfigurationList.vue?vue&type=script&lang=js&"
import style0 from "./BusDataCenterConfigurationList.vue?vue&type=style&index=0&id=5b092863&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b092863",
  null
  
)

export default component.exports